module.exports = __webpack_public_path__ + "static/react-37fe8322b169ddbdeabf75930e886ac6.png";